"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipoEsportazioneCertificazioniEnumToJSON = exports.TipoEsportazioneCertificazioniEnumFromJSONTyped = exports.TipoEsportazioneCertificazioniEnumFromJSON = exports.TipoEsportazioneCertificazioniEnum = void 0;
/**
 *
 *
 * 0 = NdgCertificati
 *
 * 1 = NdgNonCertificati
 *
 * 2 = NdgConDatiParziali
 * @export
 * @enum {string}
 */
var TipoEsportazioneCertificazioniEnum;
(function (TipoEsportazioneCertificazioniEnum) {
    TipoEsportazioneCertificazioniEnum[TipoEsportazioneCertificazioniEnum["NUMBER_0"] = 0] = "NUMBER_0";
    TipoEsportazioneCertificazioniEnum[TipoEsportazioneCertificazioniEnum["NUMBER_1"] = 1] = "NUMBER_1";
    TipoEsportazioneCertificazioniEnum[TipoEsportazioneCertificazioniEnum["NUMBER_2"] = 2] = "NUMBER_2";
})(TipoEsportazioneCertificazioniEnum = exports.TipoEsportazioneCertificazioniEnum || (exports.TipoEsportazioneCertificazioniEnum = {}));
function TipoEsportazioneCertificazioniEnumFromJSON(json) {
    return TipoEsportazioneCertificazioniEnumFromJSONTyped(json, false);
}
exports.TipoEsportazioneCertificazioniEnumFromJSON = TipoEsportazioneCertificazioniEnumFromJSON;
function TipoEsportazioneCertificazioniEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TipoEsportazioneCertificazioniEnumFromJSONTyped = TipoEsportazioneCertificazioniEnumFromJSONTyped;
function TipoEsportazioneCertificazioniEnumToJSON(value) {
    return value;
}
exports.TipoEsportazioneCertificazioniEnumToJSON = TipoEsportazioneCertificazioniEnumToJSON;
